// Metrics Setup (Provider, Reader, Exporter)
import {
  MeterProvider,
  PeriodicExportingMetricReader,
} from "@opentelemetry/sdk-metrics";
import { OTLPMetricExporter } from "@opentelemetry/exporter-metrics-otlp-http";

/**
 * Sets up OpenTelemetry Metrics: provider, collector, and exporter.
 */
export function initMetrics(): void {
  const collectorOptions = {
    url: "https://otlp.telemetryhub.com/v1/metrics",
    headers: {
      "content-type": "application/json",
    },
    concurrencyLimit: 1, // an optional limit on pending requests
  };

  const meterProvider = new MeterProvider({});
  const metricExporter = new OTLPMetricExporter(collectorOptions);

  meterProvider.addMetricReader(
    new PeriodicExportingMetricReader({
      exporter: metricExporter,
      exportIntervalMillis: 60000,
    })
  );
}
